(function securityDataControllerDefinition() {
    'use strict';

    angular.module('SecurityData')
        .controller('SecurityDataConfigModalController', [
            '$scope', '$state', '$translate', 'errorsExtend', '$q', '$modalInstance', 'adminDocumentTypeService', 'adminContainerTypeService', 'storageService', 'fileDownloader', 'entityId', 'isContainerType', 'selectedData', 'isDetail', '$filter',
            function securityDataController($scope, $state, $translate, errors, $q, $modalInstance, adminDocumentTypeService, adminContainerTypeService, storageService, fileDownloader, entityId, isContainerType, selectedData, isDetail, $filter) {
                $scope.entityId = entityId;
                $scope.isContainerType = isContainerType;
                $scope.selectedData = selectedData;
                $scope.isDetail = isDetail;


                $scope.load = function () {
                    $scope.items = [];
                    $scope.resultList = [];

                    if ($scope.isContainerType) {
                        adminContainerTypeService.getById($scope.entityId).then(function (result) {
                            $scope.LoadMetadata(result);
                        }, function (error) {
                            errors.showError(error);
                        });
                    }
                    else {
                        adminDocumentTypeService.getById($scope.entityId).then(function (result) {
                            $scope.LoadMetadata(result);
                        }, function (error) {
                            errors.showError(error);
                        });
                    }
                };

                $scope.LoadMetadata = function (securityData) {
                    var metadatas = [];

                    if (!$scope.selectedData) {
                        $scope.selectedData = [];
                    }

                    if ($scope.selectedData[0]) {
                        $scope.selectedData.forEach(function (item) {
                            $scope.resultList.push(item);
                        })
                    }
                    else {
                        if ($scope.selectedData.metadatas) {
                            $scope.selectedData.metadatas.forEach(function (meta) {
                                $scope.resultList.push(meta);
                            })
                        }
                    }

                    securityData.metadata.forEach(function (metadata) {
                        if (metadata.metadataType == 'combo' || metadata.metadataType == 'comboKV') {
                            var selectedItems = [];
                            var optionValues = JSON.parse(metadata.optionValues);
                            var values = [];
                            var checked = false;
                            var allValues = false;

                            $scope.resultList.forEach(function (data) {
                                if (data.metadataId == metadata.metadataId) {
                                    if (data.values && data.values != '') {
                                        var datavalues = JSON.parse(data.values)
                                        datavalues.forEach(function (val) {
                                            values.push($filter('filter')(optionValues, { value: val.value }, true)[0]);
                                        })
                                    }

                                    allValues = data.allValues;
                                    checked = true;
                                }
                            });

                            selectedItems = values;

                            metadatas.push(
                                {
                                    selectedItems: selectedItems,
                                    checked: checked,
                                    allValues: allValues,
                                    metadataId: metadata.metadataId,
                                    metadataType: metadata.metadataType,
                                    metadataSystemName: metadata.metadataSystemName,
                                    metadataLabel: metadata.metadataLabel,
                                    metadataOptions: optionValues
                                });
                        }
                    });

                    $scope.items = metadatas;
                }

                $scope.toggleCombo = function (item) {
                    item.checked = item.allValues || item.selectedItems.length > 0;
                };

                $scope.toggleItems = function (item) {
                    if (!item.checked) {
                        item.selectedItems = [];
                        item.allValues = false;
                    }
                }

                $scope.toggleAllvalues = function (item) {
                    if (item.allValues) {
                        if ($scope.inputWidth != $('[name="dataCombo"]').find("input").first().width()) {
                            $scope.inputWidth = $('[name="dataCombo"]').find("input").first().width();
                        }
                        item.checked = true;
                        item.selectedItems = [];
                        $scope.toggleItems(item);
                    }
                    if ($scope.inputWidth != $('[name="dataCombo"]').find("input").first().width()) {
                        $('[name="dataCombo"]').find("input").first().width($scope.inputWidth);
                    }
                }



                $scope.cancel = function () {
                    $modalInstance.close($scope.selectedData);
                };

                $scope.ok = function () {

                    var result = {
                        id: $scope.entityId,
                        metadatas: []
                    };

                    var dataValue = [];
                    var isValid = true;

                    $scope.items.forEach(function (item) {
                        if (item.checked) {
                            if (item.selectedItems.length > 0) {
                                var metadata = {
                                    metadataId: item.metadataId,
                                    systemName: item.metadataSystemName,
                                    values: "",
                                    allValues: item.allValues
                                };

                                if (!item.selectedItems[0].value) {
                                    item.selectedItems.forEach(function (val) {
                                        var v = {
                                            value: "",
                                        }
                                        v.value = val;
                                        dataValue.push(v);
                                        metadata.values = angular.toJson(dataValue);
                                    })
                                }
                                else {
                                    var options = []; 
                                    item.selectedItems.forEach(function (val) {
                                        // no guardo la descripcion
                                        options.push({ value: val.value })
                                    });

                                    metadata.values = angular.toJson(options);
                                }
                                result.metadatas.push(metadata);
                            }
                            else {
                                if (!item.allValues) {
                                    errors.showError($filter('translate')("SecurityDataMetadataNotSelected") + item.metadataLabel);
                                    isValid = false;
                                } else {
                                    var metadata = {
                                        metadataId: item.metadataId,
                                        systemName: item.metadataSystemName,
                                        values: "",
                                        allValues: item.allValues
                                    };
                                    result.metadatas.push(metadata);
                                }
                            }
                        }

                    });

                    if (isValid) {
                        $modalInstance.close(result);
                    }
                };

                $scope.load();

            }]);
})();